export default "curl -X POST {{url}} -H \"api-key: {{apiKey}}\" -F \"file[]={{image1}}\" -F \"file[]={{image2}}\"\n"